import React, {Component} from 'react';
import withStyles from "@material-ui/core/styles/withStyles";
import {Tooltip, Typography} from "@material-ui/core";
import ListDesignerHoc from "../../../../../../HocHelpers/ListDesignerHoc";
import FormField from "../../../../../../Utils/Form/Fields/FormField";
import {valueHandlerDefault} from "../../../../../../Utils/Form/FormDynamic/Utils/valueHandler";
import ColorPickerPopover from "../../../../../../Utils/ColorPickerPopover";
import {chartColors} from "../../../../../../Utils/ChartUtils/chartColors";
import findByString from "../../../../../../Utils/Form/FormDynamic/Utils/getValueByString";
import TypographySetup from "../../../../../../Utils/TypographySetup";
import BarRechartForm from "./BarRechartForm";
import PieRechartForm from "./PieRechartForm";
import LineRechartForm from "./LineRechartForm";
import ComposedRechartForm from "./ComposedRechartForm";
import {multiLanguageValue} from "../../../../../JsonScreen/Utils/lib";

const styles = () => ({
    table: {
        width: '100%',
        borderSpacing: 0,
        border: '1px solid #fff',
        borderCollapse: 'collapse'
    },
    tableCellLabel: {
        paddingLeft: 10,
        width: '105px',
        border: '1px solid',
        borderColor: '#ebebeb'
    },
    tableCell: {
        minWidth: '100px',
        border: '1px solid',
        borderColor: '#ebebeb'
    },
    tableCellInput: {
        width: '50%',
        border: '1px solid',
        borderColor: '#ebebeb',
        //paddingLeft: 10,
    },
    buttonLine: {
        padding: '1px 8px 1px 3px',
        justifyContent: 'left',
        color: 'black'
    },
});

class ChartForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            fields: {
                type: {
                    name: 'type',
                    path: 'chartProps.type',
                    label: 'Type',
                    type: 'autocomplete', options: [
                        {label: 'Bar', value: 'barRechart'},
                        {label: 'Line', value: 'lineRechart'},
                        {label: 'Pie', value: 'pieRechart'},
                        {label: 'Pie Narrow', value: 'pieNarrowRechart'},
                        {label: 'Composed', value: 'composedRechart'},
                    ]
                },
                hideTitle: {
                    name: 'hideTitle',
                    path: 'chartProps.hideTitle',
                    type: 'switch',
                },
                showAdvancedFilter: {
                    name: 'showAdvancedFilter',
                    path: 'chartProps.showAdvancedFilter',
                    type: 'switch'
                }
            },
            barFields: {
                indexBy: {
                    name: 'indexBy',
                    path: 'chartProps.indexBy',
                    label: 'Index By',
                    type: 'autocomplete'
                },
                enableGridX: {
                    name: "enableGridX",
                    path: 'chartProps.enableGridX',
                    type: "switch"
                },
                enableGridY: {
                    name: "enableGridY",
                    path: 'chartProps.enableGridY',
                    type: "switch"
                },
                enableLabel: {
                    name: "enableLabel",
                    path: "chartProps.enableLabel",
                    type: 'switch'
                },
                stacked: {
                    name: "stacked",
                    path: "chartProps.stacked",
                    type: 'switch'
                }
            },
            pieFields: {
                valueColumn: {
                    name: 'valueColumn',
                    path: 'chartProps.valueColumn',
                    label: 'Value Column',
                    type: 'autocomplete'
                },
                labelColumn: {
                    name: 'labelColumn',
                    path: 'chartProps.labelColumn',
                    label: 'Label Column',
                    type: 'autocomplete'
                },
                enableRadialLabels: {
                    name: 'enableRadialLabels',
                    path: 'chartProps.enableRadialLabels',
                    type: 'switch'
                },
                showNameInLabel: {
                    name: 'showNameInLabel',
                    path: 'chartProps.showNameInLabel',
                    type: 'switch'
                },
                enableSlicesLabels: {
                    name: 'enableSlicesLabels',
                    path: 'chartProps.enableSlicesLabels',
                    type: 'switch'
                },
            },
            pieNarrowFields: {
                valueColumn: {
                    name: 'valueColumn',
                    path: 'chartProps.valueColumn',
                    label: 'Value Column',
                    type: 'autocomplete'
                },
                labelColumn: {
                    name: 'labelColumn',
                    path: 'chartProps.labelColumn',
                    label: 'Label Column',
                    type: 'autocomplete'
                },
                enableRadialLabels: {
                    name: 'enableRadialLabels',
                    path: 'chartProps.enableRadialLabels',
                    type: 'switch'
                },
                showNameInLabel: {
                    name: 'showNameInLabel',
                    path: 'chartProps.showNameInLabel',
                    type: 'switch'
                },
                enableSlicesLabels: {
                    name: 'enableSlicesLabels',
                    path: 'chartProps.enableSlicesLabels',
                    type: 'switch'
                },
                paddingAngle: {
                    name: 'paddingAngle',
                    path: 'chartProps.paddingAngle',
                    type: 'number'
                },
                narrowSource: {
                    name: 'narrowSource',
                    path: 'chartProps.narrowSource',
                    type: 'string'
                }
            },
            lineFields: {
                indexBy: {
                    name: 'indexBy',
                    path: 'chartProps.indexBy',
                    label: 'Index By',
                    type: 'autocomplete'
                },
                enableGridX: {
                    name: "enableGridX",
                    path: 'chartProps.enableGridX',
                    type: "switch"
                },
                enableGridY: {
                    name: "enableGridY",
                    path: 'chartProps.enableGridY',
                    type: "switch"
                },
                lineStyle: {
                    name: 'lineStyle',
                    label: 'Line Style',
                    path: 'chartProps.lineStyle',
                    type: 'autocomplete',
                    options: [
                        {label: 'Basis', value: 'basis'},
                        {label: 'Cardinal', value: 'cardinal'},
                        {label: 'CatmullRom', value: 'catmullRom'},
                        {label: 'Linear', value: 'linear'},
                        {label: 'MonotoneY', value: 'monotoneY'},
                        {label: 'MonotoneX', value: 'monotoneX'},
                        {label: 'Natural', value: 'natural'},
                        {label: 'Step', value: 'step'},
                        {label: 'Step After', value: 'stepAfter'},
                        {label: 'Step Before', value: 'stepBefore'},
                    ]
                },
                enablePoints: {
                    name: 'enablePoints',
                    path: 'chartProps.enablePoints',
                    type: 'switch'
                },
                background: {
                    name: 'background',
                    path: 'chartProps.background',
                    label: 'Background',
                    type: 'colorPicker'
                }
            },
            composedFields: {
                indexBy: {
                    name: 'indexBy',
                    path: 'chartProps.indexBy',
                    label: 'Index By',
                    type: 'autocomplete'
                },
                enableGridX: {
                    name: "enableGridX",
                    path: 'chartProps.enableGridX',
                    type: "switch"
                },
                enableGridY: {
                    name: "enableGridY",
                    path: 'chartProps.enableGridY',
                    type: "switch"
                },
                background: {
                    name: 'background',
                    path: 'chartProps.background',
                    label: 'Background',
                    type: 'colorPicker'
                }
            },
            anchorColorPicker: null
        };
    }

    setAnchorColorPicker = (e) => {
        this.setState({anchorColorPicker: e.currentTarget})
    };

    barSettings = () => {
        const {barFields} = this.state;
        const {classes, data, chartChange, pivotGeneratedColumns, chartChangeAutoComplete, userLanguage} = this.props;
        let columnsSuggestions = (pivotGeneratedColumns && pivotGeneratedColumns.length > 0) ? pivotGeneratedColumns : data.columns || [];
        let newColumns = columnsSuggestions.map(el => {
            const multiLanguageLabel = multiLanguageValue(el.label, userLanguage)
            return {label: multiLanguageLabel, value: el.name}
        });
        return (
            <div>
                <table className={classes.table}>
                    <tbody>
                    <tr>
                        <td className={classes.tableCellLabel}>{barFields.indexBy.label}</td>
                        <td className={classes.tableCell}>
                            <FormField path={barFields.indexBy.path}
                                       field={barFields.indexBy}
                                       options={newColumns}
                                       values={data}
                                       onChangeAutoComplete={chartChangeAutoComplete}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td className={classes.tableCellLabel}>Labels</td>
                        <td className={classes.tableCell}>
                            <FormField path={barFields.enableLabel.path}
                                       field={barFields.enableLabel}
                                       defaultValue={true}
                                       values={data}
                                       onChange={chartChange}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td className={classes.tableCellLabel}>Grid X</td>
                        <td className={classes.tableCell}
                        >
                            <FormField path={barFields.enableGridX.path}
                                       field={barFields.enableGridX}
                                       values={data}
                                       onChange={chartChange}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td className={classes.tableCellLabel}>Grid Y</td>
                        <td className={classes.tableCell}
                        >
                            <FormField path={barFields.enableGridY.path}
                                       field={barFields.enableGridY}
                                       defaultValue={true}
                                       values={data}
                                       onChange={chartChange}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td className={classes.tableCellLabel}>Stacked</td>
                        <td className={classes.tableCell}
                        >
                            <FormField path={barFields.stacked.path}
                                       field={barFields.stacked}
                                       defaultValue={true}
                                       values={data}
                                       onChange={chartChange}
                            />
                        </td>
                    </tr>
                    </tbody>
                </table>
                <BarRechartForm
                    userLanguage={userLanguage}
                />
            </div>
        )
    };

    pieSettings = () => {
        const {pieFields} = this.state;
        const {classes, data, chartChangeAutoComplete, pivotGeneratedColumns, chartChange, userLanguage} = this.props;
        let valueColumns = [];
        let isEnableRadialLabel = valueHandlerDefault(data, pieFields.enableRadialLabels.path);
        const isPivotColumns = pivotGeneratedColumns && pivotGeneratedColumns.length > 0;
        let columnsSuggestions = isPivotColumns ? pivotGeneratedColumns : data.columns || [];
        columnsSuggestions.forEach(v => {
            const multiLanguageLabel = multiLanguageValue(v.label, userLanguage)
            if (!isPivotColumns && v.type === 'number' || v.type === 'integer' || v.type === 'duration') {
                valueColumns.push({label: multiLanguageLabel, value: v.name});
                return
            }
            if (isPivotColumns) {
                valueColumns.push({label: multiLanguageLabel, value: v.name})
            }
        });
        let newColumns = columnsSuggestions.map(el => {
            const multiLanguageLabel = multiLanguageValue(el.label, userLanguage)
            return {label: multiLanguageLabel, value: el.name}
        });
        return (
            <div>
                <table className={classes.table}>
                    <tbody>
                    <tr>
                        <td className={classes.tableCellLabel}>{pieFields.valueColumn.label}</td>
                        <td className={classes.tableCell}>
                            <FormField path={pieFields.valueColumn.path}
                                       field={pieFields.valueColumn}
                                       values={data}
                                       options={valueColumns}
                                       onChangeAutoComplete={chartChangeAutoComplete}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td className={classes.tableCellLabel}>{pieFields.labelColumn.label}</td>
                        <td className={classes.tableCell}>
                            <FormField path={pieFields.labelColumn.path}
                                       field={pieFields.labelColumn}
                                       values={data}
                                       options={newColumns}
                                       onChangeAutoComplete={chartChangeAutoComplete}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td className={classes.tableCellLabel}>Radial Labels</td>
                        <td className={classes.tableCell}>
                            <FormField path={pieFields.enableRadialLabels.path}
                                       field={pieFields.enableRadialLabels}
                                       defaultValue={true}
                                       values={data}
                                       onChange={chartChange}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td className={classes.tableCellLabel}>Show Total</td>
                        <td className={classes.tableCell}>
                            <FormField path={pieFields.labelColumn.path}
                                       field={pieFields.labelColumn}
                                       values={data}
                                       options={newColumns}
                                       onChangeAutoComplete={chartChangeAutoComplete}
                            />
                        </td>
                    </tr>
                    {isEnableRadialLabel && (
                        <tr>
                            <td className={classes.tableCellLabel}>Show name in label</td>
                            <td>
                                <FormField path={pieFields.showNameInLabel.path}
                                           field={pieFields.showNameInLabel}
                                           defaultValue={false}
                                           values={data}
                                           onChange={chartChange}
                                />
                            </td>
                        </tr>
                    )}
                    {/*<tr>*/}
                    {/*    <td className={classes.tableCellLabel}>Slices Labels</td>*/}
                    {/*    <td className={classes.tableCell}>*/}
                    {/*        <FormField path={pieFields.enableSlicesLabels.path}*/}
                    {/*                   field={pieFields.enableSlicesLabels}*/}
                    {/*                   defaultValue={true}*/}
                    {/*                   values={data}*/}
                    {/*                   onChange={chartChange}*/}
                    {/*        />*/}
                    {/*    </td>*/}
                    {/*</tr>*/}
                    </tbody>
                </table>
                <PieRechartForm
                    userLanguage={userLanguage}
                />
            </div>
        )
    };
    pieNarrowSettings = () => {
        const {pieNarrowFields} = this.state;
        const {classes, data, chartChangeAutoComplete, pivotGeneratedColumns, chartChange, userLanguage} = this.props;
        let valueColumns = [];
        let isEnableRadialLabel = valueHandlerDefault(data, pieNarrowFields.enableRadialLabels.path);
        const isPivotColumns = pivotGeneratedColumns && pivotGeneratedColumns.length > 0;
        let columnsSuggestions = isPivotColumns ? pivotGeneratedColumns : data.columns || [];
        columnsSuggestions.forEach(v => {
            const multiLanguageLabel = multiLanguageValue(v.label, userLanguage)
            if (!isPivotColumns && v.type === 'number' || v.type === 'integer' || v.type === 'duration') {
                valueColumns.push({label: multiLanguageLabel, value: v.name});
                return
            }
            if (isPivotColumns) {
                valueColumns.push({label: multiLanguageLabel, value: v.name})
            }
        });
        let newColumns = columnsSuggestions.map(el => {
            const multiLanguageLabel = multiLanguageValue(el.label, userLanguage)
            return {label: multiLanguageLabel, value: el.name}
        });
        return (
            <div>
                <table className={classes.table}>
                    <tbody>
                    <tr>
                        <td className={classes.tableCellLabel}>{pieNarrowFields.valueColumn.label}</td>
                        <td className={classes.tableCell}>
                            <FormField path={pieNarrowFields.valueColumn.path}
                                       field={pieNarrowFields.valueColumn}
                                       values={data}
                                       options={valueColumns}
                                       onChangeAutoComplete={chartChangeAutoComplete}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td className={classes.tableCellLabel}>{pieNarrowFields.labelColumn.label}</td>
                        <td className={classes.tableCell}>
                            <FormField path={pieNarrowFields.labelColumn.path}
                                       field={pieNarrowFields.labelColumn}
                                       values={data}
                                       options={newColumns}
                                       onChangeAutoComplete={chartChangeAutoComplete}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td className={classes.tableCellLabel}>Radial Labels</td>
                        <td className={classes.tableCell}>
                            <FormField path={pieNarrowFields.enableRadialLabels.path}
                                       field={pieNarrowFields.enableRadialLabels}
                                       defaultValue={true}
                                       values={data}
                                       onChange={chartChange}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td className={classes.tableCellLabel}>Padding Angle</td>
                        <td className={classes.tableCell}>
                            <FormField path={pieNarrowFields.paddingAngle.path}
                                       field={pieNarrowFields.paddingAngle}
                                       defaultValue={0}
                                       values={data}
                                       onChange={chartChange}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td className={classes.tableCellLabel}>Narrow Source</td>
                        <td className={classes.tableCell}>
                            <FormField path={pieNarrowFields.narrowSource.path}
                                       field={pieNarrowFields.narrowSource}
                                       defaultValue={0}
                                       values={data}
                                       onChange={chartChange}
                            />
                        </td>
                    </tr>
                    {isEnableRadialLabel && (
                        <tr>
                            <td className={classes.tableCellLabel}>Show name in label</td>
                            <td>
                                <FormField path={pieNarrowFields.showNameInLabel.path}
                                           field={pieNarrowFields.showNameInLabel}
                                           defaultValue={false}
                                           values={data}
                                           onChange={chartChange}
                                />
                            </td>
                        </tr>
                    )}

                    </tbody>
                </table>
                <PieRechartForm
                    userLanguage={userLanguage}
                />
            </div>
        )
    };
    lineSettings = () => {
        const {lineFields, anchorColorPicker} = this.state;
        const {
            classes,
            data,
            chartChange,
            pivotGeneratedColumns,
            chartChangeAutoComplete,
            chartPropsChangeColor,
            userLanguage
        } = this.props;
        let columnsSuggestions = (pivotGeneratedColumns && pivotGeneratedColumns.length > 0) ? pivotGeneratedColumns : data.columns || [];
        let newColumns = columnsSuggestions.map(el => {
            const multiLanguageLabel = multiLanguageValue(el.label, userLanguage)
            return {label: multiLanguageLabel, value: el.name}
        });
        return (
            <div>
                <table className={classes.table}>
                    <tbody>
                    <tr>
                        <td className={classes.tableCellLabel}>{lineFields.indexBy.label}</td>
                        <td className={classes.tableCell}>
                            <FormField path={lineFields.indexBy.path}
                                       field={lineFields.indexBy}
                                       options={newColumns}
                                       values={data}
                                       onChangeAutoComplete={chartChangeAutoComplete}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td className={classes.tableCellLabel}>{lineFields.lineStyle.label}</td>
                        <td className={classes.tableCellInput}>
                            <FormField path={lineFields.lineStyle.path}
                                       field={lineFields.lineStyle}
                                       values={data}
                                       onChangeAutoComplete={chartChangeAutoComplete}
                                       options={lineFields.lineStyle.options}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td className={classes.tableCellLabel}>
                            {lineFields.background.label}
                        </td>
                        <td className={classes.tableCellInput}>
                            <div style={{
                                margin: '5px 0 0 5px',
                                padding: '5px',
                                background: '#fff',
                                borderRadius: '1px',
                                boxShadow: '0 0 0 1px rgba(0,0,0,.1)',
                                display: 'inline-block',
                                cursor: 'pointer',
                            }} onClick={(e) => this.setAnchorColorPicker(e)}>
                                <Tooltip title={'Select Color'}>
                                    <div style={{
                                        width: '36px',
                                        height: '14px',
                                        borderRadius: '2px',
                                        background: findByString(data, lineFields.background.path) || 'rgba(0,0,0,1)'
                                    }}/>
                                </Tooltip>
                            </div>
                            <ColorPickerPopover
                                open={Boolean(anchorColorPicker)}
                                close={() => this.setState({anchorColorPicker: null})}
                                complete={chartPropsChangeColor}
                                type={"block"}
                                path={lineFields.background.path}
                                colors={chartColors}
                                anchorEl={anchorColorPicker}
                                color={findByString(data, lineFields.background.path)}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td className={classes.tableCellLabel}>Points</td>
                        <td className={classes.tableCell}>
                            <FormField path={lineFields.enablePoints.path}
                                       field={lineFields.enablePoints}
                                       defaultValue={true}
                                       values={data}
                                       onChange={chartChange}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td className={classes.tableCellLabel}>Grid X</td>
                        <td className={classes.tableCell}
                        >
                            <FormField path={lineFields.enableGridX.path}
                                       field={lineFields.enableGridX}
                                       values={data}
                                       onChange={chartChange}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td className={classes.tableCellLabel}>Grid Y</td>
                        <td className={classes.tableCell}
                        >
                            <FormField path={lineFields.enableGridY.path}
                                       field={lineFields.enableGridY}
                                       defaultValue={true}
                                       values={data}
                                       onChange={chartChange}
                            />
                        </td>
                    </tr>
                    </tbody>
                </table>
                <LineRechartForm
                    userLanguage={userLanguage}
                />
            </div>
        )
    };

    composedSettings = () => {
        const {composedFields, anchorColorPicker} = this.state;
        const {classes, data, chartChange, pivotGeneratedColumns, chartChangeAutoComplete, chartPropsChangeColor,
            userLanguage
        } = this.props;
        let columnsSuggestions = (pivotGeneratedColumns && pivotGeneratedColumns.length > 0) ? pivotGeneratedColumns : data.columns || [];
        let newColumns = columnsSuggestions.map(el => {
            const multiLanguageLabel = multiLanguageValue(el.label, userLanguage)
            return {label: multiLanguageLabel, value: el.name}
        });
        return (
            <div>
                <table className={classes.table}>
                    <tbody>
                    <tr>
                        <td className={classes.tableCellLabel}>{composedFields.indexBy.label}</td>
                        <td className={classes.tableCell}>
                            <FormField path={composedFields.indexBy.path}
                                       field={composedFields.indexBy}
                                       options={newColumns}
                                       values={data}
                                       onChangeAutoComplete={chartChangeAutoComplete}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td className={classes.tableCellLabel}>
                            {composedFields.background.label}
                        </td>
                        <td className={classes.tableCellInput}>
                            <div style={{
                                margin: '5px 0 0 5px',
                                padding: '5px',
                                background: '#fff',
                                borderRadius: '1px',
                                boxShadow: '0 0 0 1px rgba(0,0,0,.1)',
                                display: 'inline-block',
                                cursor: 'pointer',
                            }} onClick={(e) => this.setAnchorColorPicker(e)}>
                                <Tooltip title={'Select Color'}>
                                    <div style={{
                                        width: '36px',
                                        height: '14px',
                                        borderRadius: '2px',
                                        background: findByString(data, composedFields.background.path) || 'rgba(0,0,0,1)'
                                    }}/>
                                </Tooltip>
                            </div>
                            <ColorPickerPopover
                                open={Boolean(anchorColorPicker)}
                                close={() => this.setState({anchorColorPicker: null})}
                                complete={chartPropsChangeColor}
                                type={"block"}
                                path={composedFields.background.path}
                                colors={chartColors}
                                anchorEl={anchorColorPicker}
                                color={findByString(data, composedFields.background.path)}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td className={classes.tableCellLabel}>Grid X</td>
                        <td className={classes.tableCell}>
                            <FormField path={composedFields.enableGridX.path}
                                       field={composedFields.enableGridX}
                                       values={data}
                                       onChange={chartChange}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td className={classes.tableCellLabel}>Grid Y</td>
                        <td className={classes.tableCell}>
                            <FormField path={composedFields.enableGridY.path}
                                       field={composedFields.enableGridY}
                                       defaultValue={true}
                                       values={data}
                                       onChange={chartChange}
                            />
                        </td>
                    </tr>
                    </tbody>
                </table>
                <ComposedRechartForm
                    userLanguage={userLanguage}
                />
            </div>
        )
    };

    renderFormByChartType = (chartType) => {
        switch (chartType) {
            case 'barRechart':
                return (
                    <>
                        <Typography align={"center"} style={{background: 'rgba(0,0,0,0.03)'}}>Bar Settings</Typography>
                        {this.barSettings()}
                    </>
                );
            case 'lineRechart':
                return (
                    <>
                        <Typography align={"center"} style={{background: 'rgba(0,0,0,0.03)'}}>Line Settings</Typography>
                        {this.lineSettings()}
                    </>
                );
            case 'pieRechart':
                return (
                    <>
                        <Typography align={"center"} style={{background: 'rgba(0,0,0,0.03)'}}>Pie Settings</Typography>
                        {this.pieSettings()}
                    </>
                );
            case 'pieNarrowRechart':
                return (
                    <>
                        <Typography align={"center"} style={{background: 'rgba(0,0,0,0.03)'}}>Pie Settings</Typography>
                        {this.pieNarrowSettings()}
                    </>
                );
            case 'composedRechart':
                return (
                    <>
                        <Typography align={"center"} style={{background: 'rgba(0,0,0,0.03)'}}>Composed
                            Settings</Typography>
                        {this.composedSettings()}
                    </>
                );
            default:
                return <></>
        }
    };

    renderChartForm = () => {
        const {classes, chartChangeAutoComplete, chartChange, data, setTitleStyles} = this.props;
        const {fields} = this.state;
        let chartType = valueHandlerDefault(data, fields.type.path);
        return (
            <div>
                <table className={classes.table}>
                    <tbody>
                    <tr>
                        <td className={classes.tableCellLabel}>
                            {fields.type.label}
                        </td>
                        <td className={classes.tableCellInput}>
                            <FormField field={fields.type}
                                       onChangeAutoComplete={chartChangeAutoComplete}
                                       values={data}
                                       options={fields.type.options}
                                       path={fields.type.path}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td className={classes.tableCellLabel}>
                            Hide Label
                        </td>
                        <td className={classes.tableCellInput}>
                            <div style={{display: 'flex'}}>
                                <div style={{flexGrow: 1}}>
                                    <FormField field={fields.hideTitle}
                                               onChange={chartChange}
                                               values={data}
                                               path={fields.hideTitle.path}
                                    />
                                </div>
                                {!data.chartProps.hideTitle && (
                                    <TypographySetup
                                        values={data.chartProps.title.styles}
                                        defaultSize={16}
                                        setValues={setTitleStyles}
                                        updateOnChange
                                    />
                                )}
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td className={classes.tableCellLabel}>
                            Advanced Filter
                        </td>
                        <td className={classes.tableCellInput}>
                            <FormField field={fields.showAdvancedFilter}
                                       onChange={chartChange}
                                       values={data}
                                       path={fields.showAdvancedFilter.path}
                            />
                        </td>
                    </tr>
                    </tbody>
                </table>
                {this.renderFormByChartType(chartType)}
            </div>
        )
    };

    render() {
        return (
            this.renderChartForm()
        )
    }
}

export default ListDesignerHoc(withStyles(styles)(ChartForm));